const trackingDynpack = require('od-tracking/dynpack');
const commonParser = require('od-modules/parsers/dynpack_common');
const ACTION = {
    NO_ACCOMMODATION_RESULTS: 'hotels',
    NO_ITINERARIES_RESULTS: 'flights',
    BROKEN_FLOW_ERROR: 'broken_flow_error',
    BACKEND_SEARCH_ERROR: 'backend_search_error',
    INVALID_SEARCH: 'invalid_search',
    FAIL_LOAD: 'fail_load',
};
const LABEL = {
    NO_ACCOMMODATION_RESULTS: 'hotel',
    NO_ITINERARIES_RESULTS: 'flight',
    BROKEN_FLOW_ERROR: 'broken_flow_error',
    BACKEND_SEARCH_ERROR: 'backend_search_error',
    INVALID_SEARCH: 'invalid_search',
    FAIL_LOAD: 'fail_load',
};
const MODULES_DATA = {
    sessionExpired: {
        parse() {
            const searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
            const firstFlight = searchParameters.searchSegments[0];
            const lastFlight = searchParameters.searchSegments[searchParameters.searchSegments.length - 1];
            const {numAdults, numChildren, numInfants} = searchParameters;

            return {
                template: 'sessionExpired',
                tracking: trackingDynpack('error_management_sessionExpired'),
                formatDate: (date) => Odigeo.Utils.formatDate(date, Odigeo.SessionScope.websiteDateFormats.dialogDateExpireErrorCallUsFormat),
                departureCity: firstFlight.departure.city,
                destinationCity: firstFlight.destination.city,
                firstFlightDate: firstFlight.dateStr,
                lastFlightDate: lastFlight.dateStr,
                paxToString: (keys) => commonParser.getPassengerTranslations({
                    numAdults,
                    numChildren,
                    numInfants,
                }, keys),
            };
        },
    },
    packageNotAvailable: {
        parse: (errorCode) => {
            return {
                trackErrorAction: ACTION[errorCode],
                trackErrorLabel: LABEL[errorCode],
                template: 'packageNotAvailable',
                tracking: trackingDynpack('error_management_packageNotAvailable'),
            };
        },
    },
    noResults: {
        parse: (errorCode) => {
            return {
                trackErrorAction: ACTION[errorCode],
                trackErrorLabel: LABEL[errorCode],
                template: 'noResults',
                tracking: trackingDynpack('error_management_noResults'),
            };
        },
    },
};


module.exports = Backbone.Model.extend({
    update(module, errorCode) {
        this.set(MODULES_DATA[module].parse(errorCode));
    },
});
